import { defineStore } from 'pinia';
import axios from 'axios';

export const useCurrencyStore = defineStore('currencies', {
  state: () => ({
    currencyList: [
      '00',
      '1INCH',
      'AAVE',
      'ABT',
      'ACH',
      'ACS',
      'ACX',
      'ADA',
      'AED',
      'AERGO',
      'AERO',
      'AFN',
      'AGLD',
      'AIOZ',
      'AKT',
      'ALCX',
      'ALEO',
      'ALEPH',
      'ALGO',
      'ALICE',
      'ALL',
      'AMD',
      'AMP',
      'ANG',
      'ANKR',
      'ANT',
      'AOA',
      'APE',
      'API3',
      'APT',
      'ARB',
      'ARKM',
      'ARPA',
      'ARS',
      'ARSMEP',
      'ASM',
      'AST',
      'ATA',
      'ATOM',
      'AUCTION',
      'AUD',
      'AUDIO',
      'AURORA',
      'AVAX',
      'AVT',
      'AWG',
      'AXL',
      'AXS',
      'AZN',
      'BADGER',
      'BAL',
      'BAM',
      'BAND',
      'BAT',
      'BBD',
      'BCH',
      'BDT',
      'BGN',
      'BHD',
      'BICO',
      'BIF',
      'BIGTIME',
      'BIT',
      'BLAST',
      'BLUR',
      'BLZ',
      'BMD',
      'BND',
      'BNT',
      'BOB',
      'BOBA',
      'BOND',
      'BONK',
      'BRL',
      'BSD',
      'BSV',
      'BTC',
      'BTN',
      'BTRST',
      'BUSD',
      'BWP',
      'BYN',
      'BYR',
      'BZD',
      'C98',
      'CAD',
      'CBETH',
      'CDF',
      'CELR',
      'CGLD',
      'CHF',
      'CHZ',
      'CLF',
      'CLP',
      'CLV',
      'CNH',
      'CNY',
      'COMP',
      'COP',
      'CORECHAIN',
      'COTI',
      'COVAL',
      'COW',
      'CRC',
      'CRO',
      'CRPT',
      'CRV',
      'CTSI',
      'CTX',
      'CUC',
      'CUP',
      'CVC',
      'CVE',
      'CVX',
      'CZK',
      'DAI',
      'DAR',
      'DASH',
      'DDX',
      'DEGEN',
      'DESO',
      'DEXT',
      'DIA',
      'DIMO',
      'DJF',
      'DKK',
      'DNT',
      'DOGE',
      'DOP',
      'DOT',
      'DREP',
      'DRIFT',
      'DYP',
      'DZD',
      'EEK',
      'EGLD',
      'EGP',
      'EIGEN',
      'ELA',
      'ENJ',
      'ENS',
      'EOS',
      'ERN',
      'ETB',
      'ETC',
      'ETH',
      'ETH2',
      'EUR',
      'EURC',
      'FARM',
      'FET',
      'FIDA',
      'FIL',
      'FIS',
      'FJD',
      'FKP',
      'FLOKI',
      'FLOW',
      'FLR',
      'FORT',
      'FORTH',
      'FOX',
      'FTM',
      'FX',
      'G',
      'GAL',
      'GALA',
      'GBP',
      'GEL',
      'GFI',
      'GGP',
      'GHS',
      'GHST',
      'GIGA',
      'GIP',
      'GLM',
      'GMD',
      'GMT',
      'GNF',
      'GNO',
      'GNT',
      'GODS',
      'GRT',
      'GST',
      'GTC',
      'GTQ',
      'GUSD',
      'GYD',
      'GYEN',
      'HBAR',
      'HFT',
      'HIGH',
      'HKD',
      'HNL',
      'HNT',
      'HONEY',
      'HOPR',
      'HRK',
      'HTG',
      'HUF',
      'ICP',
      'IDEX',
      'IDR',
      'ILS',
      'ILV',
      'IMP',
      'IMX',
      'INDEX',
      'INJ',
      'INR',
      'INV',
      'IO',
      'IOTX',
      'IQD',
      'IRR',
      'ISK',
      'JASMY',
      'JEP',
      'JMD',
      'JOD',
      'JPY',
      'JTO',
      'JUP',
      'KARRAT',
      'KAVA',
      'KEEP',
      'KES',
      'KGS',
      'KHR',
      'KMF',
      'KNC',
      'KPW',
      'KRL',
      'KRW',
      'KSM',
      'KWD',
      'KYD',
      'KZT',
      'LAK',
      'LBP',
      'LCX',
      'LDO',
      'LINK',
      'LIT',
      'LKR',
      'LOKA',
      'LOOM',
      'LPT',
      'LQTY',
      'LRC',
      'LRD',
      'LRDS',
      'LSETH',
      'LSL',
      'LTC',
      'LTL',
      'LVL',
      'LYD',
      'MAD',
      'MAGIC',
      'MANA',
      'MASK',
      'MATH',
      'MATIC',
      'MCO2',
      'MDL',
      'MDT',
      'ME',
      'MEDIA',
      'METIS',
      'MGA',
      'MINA',
      'MIR',
      'MKD',
      'MKR',
      'MLN',
      'MMK',
      'MNDE',
      'MNT',
      'MOBILE',
      'MOG',
      'MONA',
      'MOODENG',
      'MOP',
      'MOVE',
      'MPL',
      'MRO',
      'MRU',
      'MSOL',
      'MTL',
      'MULTI',
      'MUR',
      'MUSE',
      'MVR',
      'MWK',
      'MXC',
      'MXN',
      'MYR',
      'MZN',
      'NAD',
      'NCT',
      'NEAR',
      'NEON',
      'NEST',
      'NGN',
      'NIO',
      'NKN',
      'NMR',
      'NOK',
      'NPR',
      'NU',
      'NZD',
      'OCEAN',
      'OGN',
      'OMG',
      'OMR',
      'ONDO',
      'OOKI',
      'OP',
      'ORCA',
      'ORN',
      'OSMO',
      'OXT',
      'PAB',
      'PAX',
      'PEN',
      'PEPE',
      'PERP',
      'PGK',
      'PHP',
      'PKR',
      'PLA',
      'PLN',
      'PLU',
      'PNG',
      'PNUT',
      'POL',
      'POLS',
      'POLY',
      'POND',
      'POWR',
      'PRCL',
      'PRIME',
      'PRO',
      'PRQ',
      'PUNDIX',
      'PYG',
      'PYR',
      'PYUSD',
      'QAR',
      'QI',
      'QNT',
      'QUICK',
      'RAD',
      'RAI',
      'RARE',
      'RARI',
      'RBN',
      'REN',
      'RENDER',
      'REP',
      'REPV2',
      'REQ',
      'RGT',
      'RLC',
      'RLY',
      'RNDR',
      'RON',
      'RONIN',
      'ROSE',
      'RPL',
      'RSD',
      'RUB',
      'RUNE',
      'RWF',
      'SAFE',
      'SAND',
      'SAR',
      'SBD',
      'SCR',
      'SD',
      'SDG',
      'SEAM',
      'SEI',
      'SEK',
      'SGD',
      'SHDW',
      'SHIB',
      'SHP',
      'SHPING',
      'SKK',
      'SKL',
      'SLL',
      'SNT',
      'SNX',
      'SOL',
      'SOS',
      'SPA',
      'SPELL',
      'SRD',
      'SSP',
      'STD',
      'STG',
      'STORJ',
      'STRK',
      'STX',
      'SUI',
      'SUKU',
      'SUPER',
      'SUSHI',
      'SVC',
      'SWELL',
      'SWFTC',
      'SYLO',
      'SYN',
      'SYP',
      'SZL',
      'T',
      'THB',
      'THETA',
      'TIA',
      'TIME',
      'TJS',
      'TMM',
      'TMT',
      'TND',
      'TNSR',
      'TONE',
      'TOP',
      'TRAC',
      'TRB',
      'TRIBE',
      'TRU',
      'TRY',
      'TTD',
      'TURBO',
      'TVK',
      'TWD',
      'TZS',
      'UAH',
      'UGX',
      'UMA',
      'UNFI',
      'UNI',
      'UPI',
      'USD',
      'USDC',
      'USDT',
      'UST',
      'UYU',
      'UZS',
      'VARA',
      'VEF',
      'VELO',
      'VES',
      'VET',
      'VGX',
      'VND',
      'VOXEL',
      'VTHO',
      'VUV',
      'WAMPL',
      'WAXL',
      'WBTC',
      'WCFG',
      'WELL',
      'WIF',
      'WLUNA',
      'WST',
      'XAF',
      'XAG',
      'XAU',
      'XCD',
      'XCN',
      'XDR',
      'XLM',
      'XMON',
      'XOF',
      'XPD',
      'XPF',
      'XPT',
      'XRP',
      'XTZ',
      'XYO',
      'YER',
      'YFI',
      'YFII',
      'ZAR',
      'ZEC',
      'ZEN',
      'ZETA',
      'ZETACHAIN',
      'ZK',
      'ZMK',
      'ZMW',
      'ZRO',
      'ZRX',
      'ZWD',
      'uBTC',
      'mBTC',
      'uLTC',
      'mLTC',
      'uETH',
      'mETH',
      'JET',
      'CANDY',
      'BNB',
      'TRX',
      'TON',
      'XMR',
    ],
  }),
  actions: {
    fetchCurrencies: async () => {
      // const baseURL = import.meta.env.VITE_JETGAMESCDN_CURRENCIES_URL;
      //
      // const result = await axios.create({ baseURL }).get('/');
      //
      // console.log(result.data);
    },
  },
});
